






























































































import Vue from "vue";
import Component from "vue-class-component";

@Component({
  props: {
    fileUrl: {
      type: String,
      required: true,
    }
  }
})
export default class PdfModalComponent extends Vue {

}
